import { render, staticRenderFns } from "./DragCardStops.vue?vue&type=template&id=06bde5c0&scoped=true"
import script from "./DragCardStops.vue?vue&type=script&lang=js"
export * from "./DragCardStops.vue?vue&type=script&lang=js"
import style0 from "./DragCardStops.vue?vue&type=style&index=0&id=06bde5c0&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "06bde5c0",
  null
  
)

export default component.exports